import React,{ useState , useEffect} from 'react';
import FormContainer from '../components/FormContainer';
import { Checkbox } from '@progress/kendo-react-inputs';
import config from '../appconfig/config.json';
import service from '../services/ApiService.js';
import Loading from '../components/Loading';
import { useHistory } from "react-router-dom";
import CusToast from '../components/CusToast';
import helper from '../factory/Helper';
import CusProgressBar from '../components/CusProgressBar';

const AcctOpeningMalaysia = (props) => {

    const detailsType='13';
    const item = { bgcolor: "#389A6E", completed: 80 };
    let timer;
    const history = useHistory();

    const [yesMYAcct, setYesMYAcct]  = useState(false);
    const [noMYAcct, setNoMYAcct] = useState(false)
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [isLoading, setIsLoading] = useState(true); 

    useEffect(() => {
        console.log('@AcctOpeningMalaysia useEffect');
        window.scrollTo(0,0);
        getData();
        return () => clearTimeout(timer);
    },[])

    const handleYesMYAcctChange = (e)=> {
     
        setYesMYAcct(e.value);
        setNoMYAcct(!e.value);
        setDisableSubmitBtn(false);
    }

    const handleNoMYAcctChange = (e)=> {
        setNoMYAcct(e.value);
        setYesMYAcct(!e.value);
        setDisableSubmitBtn(false);
    }

    const handleBack = (e) => {
        console.log('@handleBack')
 
        if(history.location.state !== undefined) {

            if(history.location.state.from === config.route.NSUploadDetails) {
                history.push(config.route.NSUploadDetails);
            }
            else if(history.location.state.from === config.route.LLPUploadDetails){
                history.push(config.route.LLPUploadDetails);
            }
            else if(history.location.state.from === config.route.ACSUploadDetails){
                history.push(config.route.ACSUploadDetails);
            }
            else {//from preview
                history.push(config.route.UploadDetails);
            }
        }
        else {
            history.push(config.route.UploadDetails);
        }
    }

    const handleSubmit = (e) => {
        // console.log('handleSubmit',formatJsonParams());

        if(helper.isTokenExpired()) {
            props.history.push(config.route.SessionExpired);
            return;
        }
 
        if(helper.isInvalidState()) {
            window.location.href =  config.link.Cancle;
            return;
        }

        saveDeclarationDetails(formatJsonParams());
    }

    const getData = () => {
        service.get().then( res => {
            if(res.data.isSucess){
                let resData = res.data.model.fields.request;
               
                if(resData.MalaysiaBizAcct){ //not first time
                    setDisableSubmitBtn(false);
                    if(resData.MalaysiaBizAcct.needMYBizAcctSetup === 'true') {
                        setYesMYAcct(true);
                        setNoMYAcct(false);
                    }   
                    else {
                        setYesMYAcct(false);
                        setNoMYAcct(true);
                    }
                }
                else { // first time
                    setDisableSubmitBtn(true);
                }
                

                setIsLoading(false)
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(err=>{
            
            setIsLoading(false);
        })
    }

    const formatJsonParams = () => {
        let params = {
            MalaysiaBizAcct:{
               needMYBizAcctSetup: yesMYAcct?true:false
            }
        }

        return params;
    }

    const saveDeclarationDetails= (params) => {
        setIsSaving(true);
        service.post(detailsType,params).then(res=>{
            setIsSaving(false);
            let resData = res.data;
            if(resData.isSucess){
                goNext();
            }
            else {
               showErrMsg(config.error.SaveApiFailed);
            }          
        })
        .catch(err => {
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        });
    }

    const goNext = () => {
        if(history.location.state !== undefined) { 
            if(history.location.state.from === config.route.Preview) {// preview
                history.goBack();
            }
            else {
                history.push(config.route.DeclarationDetails);
            }
        }
        else {//first time
            history.push(config.route.DeclarationDetails);
        }
    }
     

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    
    if(isLoading) {
        return(
            <Loading />
        )
    }
    
    return(
        <div>
            <h2 className='welcome mb-0'>Business Account Opening<br/>SME Banking</h2> 
         
            <div className="container-fluid">
                <FormContainer>
                    <div className="row around-xs inputPair elementVisible" style={{ marginTop: "1rem" }}>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div style={{textAlign:'center'}}>
                                <legend>{'Opening of Business Account in Malaysia'}</legend>
                                <p style={{fontSize:'1rem'}}>{'Please select your choice'}</p> 
                            </div>
                        </div>
                    </div>

                    <div className="row around-xs inputPair elementVisible" style={{paddingTop:'8px',paddingBottom:'12px'}}>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div style={{width:'7%',float:'left'}}>
                                <Checkbox id={'idChk1'} 
                                    checked={yesMYAcct} 
                                    onChange={handleYesMYAcctChange} 
                                    />
                            </div>
                            <div style={{width:'93%',float:'left' }}>
                                <p>
                                 Yes, I have business dealings in Malaysia and I would like to set up a Business Account with Maybank <b><i>Malaysia</i></b>.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row around-xs inputPair elementVisible" style={{paddingTop:'8px',paddingBottom:'12px'}}>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div style={{width:'7%',float:'left'}}>
                                <Checkbox id={'idChk2'} 
                                    checked={noMYAcct} 
                                    onChange={handleNoMYAcctChange} 
                                    />
                            </div>
                            <div style={{width:'93%',float:'left' }}>
                                <p>
                                No, I do not have any business dealings in Malaysia and I do not need a <b><i>Malaysia</i></b> Business Account.
                                </p>
                            </div>
                        </div>
                    </div>
             

                <div className="row around-xs inputPair elementVisible" style={{paddingTop:'8px',paddingBottom:'12px'}}>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className='box'>
                        <label>
                            <i>Note:I/We agree that my/our online application of Maybank Malaysia Business Account is subject to Maybank's approval; and Maybank will only contact me/us upon approval of our Maybank Singapore CASA online application.</i>
                        </label>
                        </div>
                    </div>
                </div>
                <CusProgressBar bgcolor={item.bgcolor} completed={item.completed} />
                <div className="padDTC" style={{textAlign: "left"}}> 
                    <div className="row around-xs inputPair elementVisible">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{paddingBottom: "20px"}}>
                            <button className="btn btn-back"  onClick={handleBack}>{config.btnName.Back}</button>
                            <button className="k-button btn btn-success btn-float-right" disabled={disableSubmitBtn} onClick={handleSubmit}>{config.btnName.Next}</button>
                        </div>
                    </div> 
                </div>
                <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} />  
                {isSaving && <Loading />} 
                </FormContainer>
            </div>
        </div>
    )
}

export default AcctOpeningMalaysia;